module.exports = new __parcel__URL__("fail.55d51340.mp3").toString();